import React from 'react'

const InputTextJSX = ({ labelText, nameValue, value, onChange, splithalf, maxLength=250 }) => {
    return (
        <>
            <div className={`col-md-${splithalf ? 3 : 6} mt-2`}>
                <div className='ms-2'>
                    <label htmlFor="" className='form-label  mb-0'>
                        {labelText}
                    </label>
                    <div className="icon-forms mb-3 mb-sm-0">
                        <input
                            type="text"
                            maxLength={maxLength}
                            className="form-control form-control-sm"
                            id={nameValue}
                            name={nameValue}
                            value={value}
                            onChange={onChange}
                        // onBlur={formik.handleBlur}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default InputTextJSX